import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <>
      {/* Inline CSS */}
      <style>{`
        .site-footer {
          margin-top: 80px;
          background: linear-gradient(180deg, #0f172a, #020617);
          color: #e5e7eb;
        }

        .footer-inner {
          display: grid;
          grid-template-columns: 1.2fr 1fr 1fr;
          gap: 40px;
          padding: 50px 20px;
          align-items: start;
        }

        .about {
          display: flex;
          gap: 14px;
          align-items: flex-start;
        }

        .logo-small {
          font-size: 36px;
          animation: floatFoot 3s ease-in-out infinite;
        }

        @keyframes floatFoot {
          0%,100% { transform: translateY(0); }
          50% { transform: translateY(-6px); }
        }

        .about strong {
          font-size: 18px;
        }

        .about p {
          font-size: 14px;
          opacity: 0.7;
          margin-top: 4px;
        }

        .footer-nav,
        .socials {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .footer-nav a,
        .socials a {
          color: #cbd5f5;
          text-decoration: none;
          font-size: 14px;
          position: relative;
          width: fit-content;
        }

        .footer-nav a::after,
        .socials a::after {
          content: "";
          position: absolute;
          bottom: -3px;
          left: 0;
          width: 0;
          height: 1px;
          background: #22c55e;
          transition: width 0.3s ease;
        }

        .footer-nav a:hover::after,
        .socials a:hover::after {
          width: 100%;
        }

        .copyright {
          border-top: 1px solid rgba(255,255,255,0.1);
          padding: 16px 20px;
          font-size: 13px;
          opacity: 0.6;
          text-align: center;
        }

        @media (max-width: 900px) {
          .footer-inner {
            grid-template-columns: 1fr;
            text-align: center;
          }

          .about {
            justify-content: center;
          }

          .footer-nav,
          .socials {
            align-items: center;
          }
        }
      `}</style>

      <footer className="site-footer">
        <div className="container footer-inner">
          <div className="about">
            <div className="logo-small">🏸</div>
            <div>
              <strong>Sportyfo</strong>
              <p>Badminton coaching, tracking & matchmaking.</p>
            </div>
          </div>

          <nav className="footer-nav">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
            <a href="#">Privacy Settings</a>
          </nav>

          {/* <div className="socials">
            <a href="#">Twitter</a>
            <a href="#">Instagram</a>
            <a href="#">Facebook</a>
          </div> */}
        </div>

        <div className="container copyright">
          © {new Date().getFullYear()} Sportyfo — All rights reserved
        </div>
      </footer>
    </>
  );
}
